<template>
  <div>
    <v-card class="mb-4">

      <apexchart type="area"
                 v-if="!loading"
                 :options="chartOptions"
                 :series="series">
      </apexchart>
    </v-card>
  </div>
</template>
<script>

import { v4 as uuid } from 'uuid';

export default {
  props: {
    group: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    metrics: {
      type: Array,
      required: true,
    },
    palette: {
      type: String,
      default: 'palette1',
    },
    team: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      headers: [
        {text: 'Date', value: 'date',},
        {text: 'Presentations Created', value: 'created_presentations'},
        {text: 'Sessions', value: 'device_sessions'},
      ],
      showTable: false,
    }
  },
  computed: {
    dates() {
      return this.metrics.map(m => m.date);
    },
    series() {
      return [
        {
          name: 'Presentations Created',
          data: this.metrics.map(m => m.created_presentations),
        },
        {
          name: 'Sessions',
          data: this.metrics.map(m => m.device_sessions),
        },
        {
          name: 'Shares',
          data: this.metrics.map(m => m.shared_links),
        },
        {
          name: 'Hits',
          data: this.metrics.map(m => m.shared_link_hits),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          group: this.group,
          height: 'auto',
          id: uuid(),
          type: 'area',
          zoom: {
            enabled: true,
          }
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        stroke: {
          curve: 'smooth',
        },
        theme: {
          palette: this.palette,
        },
        title: {
          text: 'Team activity',
          align: 'left',
        },
        xaxis: {
          type: 'datetime',
          categories: this.dates,
        },
      };
    },
  }
}
</script>
